<template>
    <transition name="slide-up">
        <div v-if="visible" class="custom-modal" ref="modal">
            <button
                type="btn"
                class="close-btn icon-btn icon-btn-white"
                @click="closeModal"
            >
                <i class="fi fi-x"></i>
            </button>

            <slot></slot>
        </div>
    </transition>

    <!-- Overlay div to close the modal when clicking outside -->
    <div v-if="visible" class="overlay" @click="closeModal"></div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        // toggles modal visibility
        visible: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['close'],
    methods: {
        closeModal() {
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.3s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
    opacity: 0;
    transform: translateY(20px);
}

.custom-modal {
    background-color: white;
    z-index: var(--z-index-modal);
    width: 500px;
    max-width: 95%;
    height: fit-content;
    position: fixed; /* Ensures the modal is positioned relative to the viewport */
    top: 50%; /* Centers the modal vertically */
    left: 50%; /* Centers the modal horizontally */
    transform: translate(-50%, -50%); /* Adjusts for the modal's size */
    border-radius: var(--radius-default);
    padding: var(--space-10) 3rem;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* semi-transparent overlay */
    background-color: rgba(0, 0, 0, 0.1);
    /* one level below the modal */
    z-index: var(--z-index-modal-overlay);
}

.close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
}

@media (max-width: 767.98px) {
    .custom-modal {
        width: 320px;
        padding: var(--space-4) 1rem;
    }
}
</style>
